"use strict";
// @ts-ignore
import('./bootstrap');
